const env = 'prod';
const xhr = new XMLHttpRequest();
xhr.open('GET', `/assets/environments/${env}.json`, false);
xhr.send(null);
export const environment: any = JSON.parse(xhr.responseText);
